module.exports = __webpack_public_path__ + "img/h.04d3ecfb.jpg";